/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/file'
export default icon
